"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleRecaptcha = void 0;
const loader_1 = require("./loader");
const helper_1 = require("../../core/library/helper");
const library_1 = require("../../core/library");
const constants_1 = require("./constants");
class GoogleRecaptcha extends library_1.Library {
    constructor(googleSiteKey) {
        super('GoogleRecaptcha', new loader_1.GoogleRecaptchaLoader(googleSiteKey));
        this.googleSiteKey = googleSiteKey;
        return (0, helper_1.withLibraryLoadCheck)(this);
    }
    getGoogleSiteKey() {
        return this.googleSiteKey;
    }
    register() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield window.grecaptcha.enterprise.execute(this.getGoogleSiteKey(), {
                action: constants_1.REGISTRATION_ACTION,
            });
            return token;
        });
    }
}
exports.GoogleRecaptcha = GoogleRecaptcha;
//# sourceMappingURL=index.js.map